import React, { useEffect, useState } from "react";
import "./styles/dashboard.css";
import { useNavigate } from "react-router-dom";
import Item from "./components/item";

function Dashboard() {
  const [user, userEmail] = useState("");
  const [task, setTask] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  const [todos, setTodos] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("email")) {
      userEmail(localStorage.getItem("email"));
      getTodos();
    } else {
      navigate("/");
    }
  }, [navigate, setTodos]);

  function showContent() {
    setShowAdd(!showAdd);
  }

  function getTodos() {
    fetch(
      "https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/dashboard",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/JSON",
          "Access-Control-Allow-Origin": "*",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => setTodos(data))
      .then(() => setTask(""))
      .catch((err) => alert(err));
  }

  function addTask(e) {
    e.preventDefault();
    let taskData = {
      email: user,
      task: task,
    };
    fetch(
      "https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/addTask",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/JSON",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(taskData),
      }
    )
      .then((res) => res.json())
      .then((data) => alert(data.data))
      .then(() => getTodos())
      .catch((err) => alert(err));
  }

  function deleteTodo(_id) {
    fetch(
      "https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/deleteTask",
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/JSON",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({ _id }),
      }
    )
      .then((res) => res.json())
      .then((data) => alert(data.data))
      .then(() => getTodos())
      .catch((err) => alert(err));
  }

  function completeTask(_id) {
    fetch(
      "https://taskmanagementbackend-810lxavxl-obaid-ur-rehmxn.vercel.app/api/completeTask",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/JSON",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({ _id }),
      }
    )
      .then((res) => res.json())
      .then((data) => alert(data.data))
      .then(() => getTodos())
      .catch((err) => alert(err));
  }

  return (
    <>
      <div className="content">
        <p className="heading">Welcome {user}</p>
        <div className="list">
          {todos.map((item) => (
            <Item
              key={item._id}
              text={item.task}
              remove={() => deleteTodo(item._id)}
              complete={() => completeTask(item._id)}
            />
          ))}
        </div>
        {showAdd ? (
          <div className="pluscontent">
            <input
              placeholder="Enter Your Task"
              type="text"
              value={task}
              onChange={(e) => setTask(e.target.value)}
            />
            <button onClick={addTask}>Add</button>
          </div>
        ) : null}
        <div className="plus" onClick={showContent}>
          +
        </div>
      </div>
    </>
  );
}

export default Dashboard;
